import React, { useState } from 'react';
import Icon from '../Icon';
import { translate } from '../../Services/translation';
import { post } from '../../Services/http';
import clsx from 'clsx';
import { dataLayerGtmSignUp } from '../../Services/Gtm.service';

interface SignInResponse {
  success: boolean;
}

export const UspSign = () => {
  const [email, setEmail] = useState('');
  const [isErrorMessageVisible, setIsErrorMessageVisible] = useState(
    false
  );
  const [isSuccessMessageVisible, setIsSuccessMessageVisible] = useState(
    false
  );

  const handleTextChanged = (event) => {
    setEmail(event.target.value);
  };

  const handleSuccess = async (data: SignInResponse) => {
    if (data.success) {
      setIsSuccessMessageVisible(true);
      setEmail('');
      setTimeout(function () {
        setIsSuccessMessageVisible(false);
      }, 10000);
    } else {
      await handleError();
    }
  };

  const handleError = async () => {
    setIsErrorMessageVisible(true);
    setEmail('');
    setTimeout(function () {
      setIsErrorMessageVisible(false);
    }, 10000);
  };

  const signMail = () => {
    var optInModel = {
      Email: email,
      Source: 'NewsletterFooterWeb',
    };
    post('/api/mailchimp/optin', optInModel)
      .then((response) => response.json())
      .then((data) => {
        dataLayerGtmSignUp({ email: optInModel.Email })
        handleSuccess(data)
      })
      .catch(() => handleError());
  };

  return (
    <div className="w-full relative">
      <input
        type="text"
        placeholder={translate('general.register.placeholder')}
        onChange={handleTextChanged}
        value={email}
        className={clsx(
          'w-full h-12 rounded bg-white text-gray-500 border-0 text-lg leading-[2.4rem] pl-[15px] align-top',
          isErrorMessageVisible && 'border border-solid border-error-500',
          isSuccessMessageVisible &&
          'border border-solid border-success-500'
        )}
      />
      <button
        onClick={signMail}
        className="bg-primary-500 text-white font-satoshi-bold text-lg leading-[2.4rem] rounded h-10 py-2 px-[10px] absolute top-1 right-1 z-[2]"
      >
        {translate('general.register')}
      </button>

      {isErrorMessageVisible && (
        <div className="flex items-center text-center text-sm p-[5px] pl-0 text-error-500">
          <Icon name="error" className="w-4 h-4 mr-[3px]" />
          {translate('general.register.failure')}
        </div>
      )}

      {isSuccessMessageVisible && (
        <div className="flex items-center text-center text-sm p-[5px] pl-0 text-success-500 [&_a]:text-success-500 [&_a]:underline">
          <Icon name="success" className="w-4 h-4 mr-[3px]" />
          <span
            dangerouslySetInnerHTML={{
              __html: translate('general.register.success'),
            }}
          ></span>
        </div>
      )}
    </div>
  );
};
